

















































































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
@Component
export default class MasterCodeMenu extends Vue {}
